import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Walk = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 2,
    key: "k0"
  }), React.createElement("path", {
    d: "M13.978 12.27c.245.368.611.647 1.031.787l2.675.892.633-1.896-2.675-.892-1.663-2.495a2.016 2.016 0 00-.769-.679l-1.434-.717a1.989 1.989 0 00-1.378-.149l-3.193.797a2.002 2.002 0 00-1.306 1.046l-1.794 3.589 1.789.895 1.794-3.589 2.223-.556-1.804 8.346-3.674 2.527 1.133 1.648 3.675-2.528c.421-.29.713-.725.82-1.225l.517-2.388 2.517 1.888.925 4.625 1.961-.393-.925-4.627a2 2 0 00-.762-1.206l-2.171-1.628.647-3.885 1.208 1.813z",
    key: "k1"
  }));
});
Walk.displayName = 'Walk';
export var WalkDimensions = {
  height: 24,
  width: 24
};